import { SVGProps } from 'react';

import { Vector } from '@moleculeone/types';
import { styled } from '../../../../stitches.config';
import { V4 } from '@moleculeone/utils';

const SVGGroup = styled('g', {});

function Part(props: any) {
  const { textPart, pivotPosition } = props;

  const bottomLeftCorner = V4.add(
    pivotPosition, // center of the text
    textPart.shift, // part position relative to pivot
    V4.mul(textPart.size, V4.vect(-0.5, 0.5)), // relative corner position
  );

  return (
    <text
      fontSize={textPart.type ? '50%' : undefined}
      x={bottomLeftCorner[0].toFixed(2)}
      y={bottomLeftCorner[1].toFixed(2)}
    >
      {textPart.text}
    </text>
  );
}

interface AtomTextProps {
  className?: HTMLElement['className'];
  text?: any;
  pos?: Vector;
  fill?: SVGProps<SVGElement>['fill'];
}

function AtomText(props: AtomTextProps) {
  const { text, pos, ...restProps } = props;

  return (
    <SVGGroup {...restProps}>
      {text.map((part: any, i: number) => (
        <Part textPart={part} pivotPosition={pos} key={String(i)} />
      ))}
    </SVGGroup>
  );
}

interface AtomTextGroupProps extends SVGProps<SVGGElement> {
  className?: HTMLElement['className'];
  center: any;
  side: any;
  pos: Vector;
  color: SVGProps<SVGElement>['fill'];
}

export function AtomTextGroup(props: AtomTextGroupProps) {
  const { center, side, pos, color, ref, ...restProps } = props;

  if (side && !center) {
    throw new Error('Invariant violated.');
  }

  return (
    <SVGGroup {...restProps}>
      <AtomText className="atom" text={center.parts} pos={pos} fill={color} data-test="atom-origin" key="center" />

      {side && <AtomText className="atom" text={side.parts} pos={V4.add(pos, side.shift)} fill={color} key="side" />}
    </SVGGroup>
  );
}
